import React from "react";
import { Autocomplete, Button, TextField, Typography } from "@mui/material";
import { CssTextField } from "../styles/styles";
import { Padding, PaletaColor } from "../styles/StylesConstantes";
import { optionsUsuarios } from "../constantes/constantes";
import { Download } from "@mui/icons-material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';


function FitroInformeGeneralComponents({
    name, handleName, cedula, handleCedula, apellido, handleApellido, 
    userTester, handleUserTester, fechaInicio, handleFechaInicio,
    fechaFin, handleFechaFin, beneficiario, handleBeneficiario
}) {




    return (
        <div style={{
            backgroundColor: PaletaColor.BLANCO,
            borderRadius: Padding.P1,
            padding: Padding.P3,
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant={'h5'} style={{}}>
                    Informe General
                </Typography>

                <div style={{}}>
                    <Button
                        fullWidth
                        variant="contained"
                        style={{
                            backgroundColor: PaletaColor.VERDE,
                            color: 'white',
                            fontWeight: 'bold',
                        }}
                        startIcon={<Download />}
                    >
                        Exportar
                    </Button>
                </div>
            </div>


            <div style={{ marginTop: Padding.P1 }} >
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{}}>
                                Nombre
                            </Typography>
                        </div>

                        <CssTextField
                            value={name}
                            onChange={(e) => handleName(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Buscar por nombre"
                            id="username"
                            autoCapitalize='none'
                            autoCorrect={false}
                            style={{
                                marginTop: Padding.P1,
                                width: '95%'
                            }}
                        />

                    </div>

                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{}}>
                                Apellido
                            </Typography>
                        </div>

                        <CssTextField
                            value={apellido}
                            onChange={(e) => handleApellido(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Buscar por apellido"
                            autoCapitalize='none'
                            autoCorrect={false}
                            style={{
                                marginTop: Padding.P1,
                                width: '95%'
                            }}
                        />
                    </div>

                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{}}>
                                Cédula
                            </Typography>
                        </div>

                        <CssTextField
                            value={cedula}
                            onChange={(e) => handleCedula(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Buscar por cédula"
                            autoCapitalize='none'
                            autoCorrect={false}
                            style={{
                                marginTop: Padding.P1,
                                // width: '95%'
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', marginTop: Padding.P2 }}>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ flex: 1, display: 'flex' }}>
                            <div style={{ flex: 1 }}>
                                <div>
                                    <Typography variant={'subtitle1'} style={{}}>
                                        Beneficiario
                                    </Typography>
                                </div>

                                <CssTextField
                                    value={beneficiario}
                                    onChange={(e) => handleBeneficiario(e.target.value)}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Buscar por nombre"
                                    autoCapitalize='none'
                                    autoCorrect={false}
                                    // autoCompleteType='email'
                                    style={{
                                        marginTop: Padding.P1,
                                        width: '95%'
                                    }}
                                />

                            </div>
                        </div>


                        <div style={{ flex: 1 }}>
                            <div>
                                <Typography variant={'subtitle1'} style={{}}>
                                    Usuarios
                                </Typography>
                            </div>

                            <Autocomplete
                                disablePortal
                                options={optionsUsuarios}
                                renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                onInputChange={(event, newInputValue) => {
                                    handleUserTester(newInputValue);
                                }}
                                value={userTester}
                                style={{
                                    marginTop: Padding.P1,
                                    width: '95%'
                                }}
                            />
                        </div>

                        <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ flex: 1 }}>
                                <div>
                                    <Typography variant={'subtitle1'} style={{}}>
                                        Fecha de inicio
                                    </Typography>
                                </div>

                                <div style={{}}>
                                    <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>

                                        <DatePicker
                                            label="Fecha de inicio"
                                            value={fechaInicio}
                                            sx={{ width: '95%' }}
                                            onChange={(newValue) => {
                                                handleFechaInicio(newValue);
                                            }}
                                            format="DD/MM/YYYY"
                                        />
                                    </LocalizationProvider>
                                </div>
                            </div>


                            <div style={{ flex: 1 }}>
                                <div>
                                    <Typography variant={'subtitle1'} style={{}}>
                                        Fecha de fin
                                    </Typography>
                                </div>
                                <div style={{}}>
                                    <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Fecha de fin"
                                            value={fechaFin}
                                            sx={{ width: '100%' }}
                                            onChange={(newValue) => {
                                                handleFechaFin(newValue);
                                            }}
                                            format="DD/MM/YYYY"
                                        />
                                    </LocalizationProvider>
                                </div>
                            </div>
                        </div>






                    </div>
                </div>

            </div>

        </div>
    )
}

export default FitroInformeGeneralComponents;